import React from 'react';
import EditForm from '../../components/EditForm/EditForm';
import './EditPoll.scss';

const EditPoll = () => {
    return (
        <div className="edit-poll">
            <div className="edit-poll__title-container">
                <p className="edit-poll__title">Editing Poll</p>
            </div>
            <div className="edit-poll__form-container">
                <EditForm />
            </div>
        </div>
    );
};

export default EditPoll;